import React from 'react';
import {connect} from 'react-redux';

import {fetchAgreement, MODALS} from 'ducks/bookings';

import {default as Modal, withModal} from 'components/Modal';
import {BaseInformation, SignaturesInformation} from './components';

import AgreementStatus from 'components/AgreementStatus';

class AgreementDetailModal extends React.Component<any> {
  componentDidMount() {
    const {agreementId} = this.props.data;

    this.props.fetchAgreement(
      {agreementId},
      this.props.storeDataExtraActions(data => data)
    );
  }

  render() {
    const {
      data: {
        sentAt,
        canBeSent,
        canBeReminded,
        canBeCancelled,
        canBeSignedManually,
        contractUrl,
        primaryTenant = {},
        secondaryTenant = {},
        guarantor = {},
        agent = {},
        agreementTypeName,
        agreementId,
        status
      },
      openSendAgreementReminderModal,
      openCancelAgreementModal,
      openSendAgreementModal,
      openSignAgreementManuallyModal,
      downloadAgreement,
      closeModal
    } = this.props;

    return (
      <Modal
        show={true}
        onClose={closeModal}
        type={Modal.MEDIUM}
        className="AgreementDetailModal">
        <Modal.Header>
          <h3>HelloSign Agreement</h3>
          <AgreementStatus status={status} />
        </Modal.Header>
        <Modal.Body>
          <BaseInformation
            canBeSent={canBeSent}
            canBeReminded={canBeReminded}
            canBeCancelled={canBeCancelled}
            canBeSignedManually={canBeSignedManually}
            sentAt={sentAt}
            contractUrl={contractUrl}
            agreementTypeName={agreementTypeName}
            openSendAgreementReminderModal={openSendAgreementReminderModal}
            openCancelAgreementModal={openCancelAgreementModal}
            openSendAgreementModal={openSendAgreementModal}
            openSignAgreementManuallyModal={openSignAgreementManuallyModal}
            downloadAgreement={downloadAgreement}
            agreementId={agreementId}
          />
          <SignaturesInformation
            primaryTenant={primaryTenant}
            secondaryTenant={secondaryTenant}
            guarantor={guarantor}
            agent={agent}
          />
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    );
  }
}

const mapDispatchToProps = {
  fetchAgreement
};

export default connect(null, mapDispatchToProps)(withModal(
  MODALS.AGREEMENT_DETAIL
)(AgreementDetailModal) as React.ComponentType<any>);
